import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSiteStatus } from "@/context/SiteStatusContext";
import MaintenancePage from "@/components/MaintenancePage";

const PASS_THROUGH = ["/connexion", "/mot-de-passe-oublie", "/reinitialiser-mot-de-passe"];

export default function MaintenanceGate({ children }) {
  const { maintenance, loaded } = useSiteStatus();
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [support, setSupport] = useState("");

  const active = loaded && maintenance?.enabled;
  useEffect(() => {
    if (active) api.get("/support/contacts").then(({ data }) => setSupport(data.whatsapp || "")).catch(() => {});
  }, [active]);

  if (!active || loading) return children;
  if (user?.role === "admin") return children;
  if (pathname.startsWith("/admin") || PASS_THROUGH.some((p) => pathname.startsWith(p))) return children;
  return <MaintenancePage data={maintenance} supportWhatsApp={support} />;
}
